(function () {
  var scrollTopPosition;
  var isVideoStarted = false;

  document.addEventListener("fullscreenchange", function () {
    if (document.fullscreenElement) {
      scrollTopPosition = window.scrollY;
    } else {
      // восстанавливаем позицию скролла при закрытии видео на весь экран
      window.scrollTo(0, scrollTopPosition);
    }
  });

  function findVideos() {
    let videos = document.querySelectorAll(".video-container .video-wrap");

    for (let i = 0; i < videos.length; i++) {
      setupVideo(videos[i]);
    }
  }

  function setupVideo(video) {
    if (video) {
      let link = video.querySelector(".video-link");
      let media = video.querySelector(".video-media");
      let button = video.querySelector(".video-button, .video-button-red");
      let id = parseMediaURL(media);

      let eventLabel = video.dataset.eventLabel;
      let eventPosition = video.dataset.eventPosition;

      if (media.naturalWidth <= 120 && media.naturalHeight <= 90) {
        media.src = "/wp-content/themes/eos/dev-images/youtube-placeholder.jpg";
      }

      video.addEventListener("click", () => {
        let iframe = createIframe(id);
        let player;

        link.remove();
        button.remove();
        video.appendChild(iframe);

        // Инициализация плеера и обработка событий
        player = new YT.Player(iframe, {
          events: {
            onStateChange: (event) =>
              onPlayerStateChange(event, eventLabel, eventPosition),
          },
        });
      });

      link.removeAttribute("href");
      video.classList.add("video--enabled");
    }
  }

  function parseMediaURL(media) {
    let imageQualityArr = [
      "maxresdefault",
      "hqdefault",
      "mqdefault",
      "sddefault",
      "default",
    ];
    let match_id = [];

    imageQualityArr.forEach(function (element) {
      let regexp = new RegExp(
        "https://i.ytimg.com/vi_webp/([a-zA-Z0-9_-]+)/" + element + ".webp"
      );
      let url = media.src;
      let match = url.match(regexp);

      if (match) {
        match_id = match[1];
      }
    });

    return match_id;
  }

  function createIframe(id) {
    let iframe = document.createElement("iframe");

    iframe.setAttribute("allowfullscreen", "");
    iframe.setAttribute("allow", "autoplay");
    iframe.setAttribute("src", generateURL(id));
    iframe.classList.add("video-media");

    return iframe;
  }

  function generateURL(id) {
    let query = "?rel=0&showinfo=0&autoplay=1&enablejsapi=1";

    return "https://www.youtube.com/embed/" + id + query;
  }

  function onPlayerStateChange(event, eventLabel, eventPosition) {
    if (event.data == YT.PlayerState.PLAYING) {
      if (!isVideoStarted) {
        dataLayer.push({
          event: "EOSCOM",
          eventCategory: "EosComEvents",
          eventAction: "video_start",
          eventLabel: eventLabel ? eventLabel : "",
          eventContent: "",
          eventPosition: eventPosition ? eventPosition : "",
          eventContext: "",
        });
        isVideoStarted = true;
      }
    } else if (event.data == YT.PlayerState.ENDED) {
      dataLayer.push({
        event: "EOSCOM",
        eventCategory: "EosComEvents",
        eventAction: "video_complete",
        eventLabel: eventLabel ? eventLabel : "",
        eventContent: "",
        eventPosition: eventPosition ? eventPosition : "",
        eventContext: "",
      });
    }
  }

  //Загрузка YouTube Player API
  var tag = document.createElement("script");
  tag.src = "https://www.youtube.com/iframe_api";
  var firstScriptTag = document.getElementsByTagName("script")[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

  findVideos();
})();
